<script setup lang="ts">
import { watch } from 'vue';
import UpdateModal from '@/modules/core/components/modals/System/UpdateModal.vue';
import { Toaster } from 'vue-sonner';
import { VueQueryDevtools } from '@tanstack/vue-query-devtools';
import StylesDebuggerComponent from '@/modules/core/components/StylesDebugger.vue';
import AppError from '@/modules/core/components/app/AppError.vue';
import ErrorBoundary from '@/modules/core/components/app/ErrorBoundary.vue';
import { useTitle } from '@vueuse/core';
import { useRoute } from 'vue-router';
import { useLocale } from '@/modules/core/composables/use-locale.ts';
import { useI18n } from 'vue-i18n';
import { provideInModal } from '@/providers/in-modal.ts';

const StylesDebugger = !import.meta.env.DEV ? () => null : StylesDebuggerComponent;

useLocale();

provideInModal(false);

const route = useRoute();
const title = useTitle();
const { t } = useI18n();

watch(
  () => `${t('common.title')} - ${t(route.meta.tabTitle || 'common.description')}`,
  (tabTitle) => (title.value = tabTitle),
);
</script>

<template>
  <ErrorBoundary>
    <RouterView />
    <UpdateModal />

    <template #fallback="{ fallback }">
      <AppError :message="fallback" />
    </template>
  </ErrorBoundary>

  <Toaster
    position="top-right"
    :toast-options="{ class: 'toast' }"
  />
  <VueQueryDevtools />
  <StylesDebugger />
</template>
